module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEqSURBVHgB7Ze7bgIxEEVnVimiVPsJ8GVJ+jw78lwiJQE63i38GXwCxUIDWmMjBiEeiykQY3FPsfKOXdwjj+VdIgAAAACAy4Xd47PaNqSI39IDH1qTJL14dp2+XFFgSPAsGj+z4TgYgc3gZtkzWwI+23cK9rXxvuCC2h3IDc5mRLbmhhEp5KPSKmc34wEzJzZ4vJpwwZnL6WRWlJLKHVgGXyvY4BTV08m0Uf95HbmSbbnFlO5DvCP4JjoFPIILKgVcjx8KLqg8xL7hHSoFjgEC5wYCp+Cr2hl817q3PmtVChgyhcxkfR8R1S3kI6JSwIa+t+GH8p4nolLg/+2p/1d6LOaJSE11C+WJyDion/r3SvPOfWozcUFqQd0Du3YkyItsXYQAAAAAAC6YOcYYxDvhVy7UAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/release-video2x.png
// module id = 5ZLF
// module chunks = 36